var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector100(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11719 0.320312C2.80219 0.320312 0.117188 3.01904 0.117188 6.35099C0.117188 7.48174 0.432187 8.55218 0.987187 9.45678C2.02219 11.2057 3.92719 12.3817 6.11719 12.3817C8.30719 12.3817 10.2122 11.2057 11.2472 9.45678C11.8022 8.55218 12.1172 7.48174 12.1172 6.35099C12.1172 3.01904 9.43219 0.320312 6.11719 0.320312ZM9.22219 5.70269L6.02719 8.6728C5.81719 8.8688 5.53219 8.97433 5.26219 8.97433C4.97719 8.97433 4.69219 8.8688 4.46719 8.64264L2.98219 7.15005C2.54719 6.71283 2.54719 5.98915 2.98219 5.55192C3.41719 5.1147 4.13719 5.1147 4.57219 5.55192L5.29219 6.27561L7.69219 4.04425C8.14219 3.62211 8.86219 3.65226 9.28219 4.10456C9.70219 4.55686 9.67219 5.26547 9.22219 5.70269Z",
    fill: "#367B3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector100);
export default __webpack_public_path__ + "static/media/Vector(100).19f90f6dcadda9013b21429ed1d11849.svg";
export { ForwardRef as ReactComponent };